import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { loadCelebration2018Completion } from '../../actions';

export function* watchLoadCelebration2018() {
  yield takeEvery('LOAD_CELEBRATION2018', function*() {
    const options = {
      url: '/sfapi/siqing/bill',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCelebration2018Completion(result.error, result.data));
  });
}

export default function* celebration2018Saga() {
  yield all([fork(watchLoadCelebration2018)]);
}
